import { useEffect, useRef } from 'react';
import { BackKeyHandler, pushBackKeyLayer } from '@smart-tv/utils/back-key-layers';

/**
 * Captures all back key presses while mounted (and enabled), so only the most recent mount receives the event.
 * only used for error dialog for now
 * @param handler - Function to handle back key events.
 */
export const useBackKeyLayer = (handler: BackKeyHandler, enabled = true) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    if (!enabled) return;
    return pushBackKeyLayer((event) => handlerRef.current(event));
  }, [enabled]);
};

export default useBackKeyLayer;
